var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BubbleChartWrapper',{key:`building-bubble--${_vm.building.id}-${_vm.key}`,staticClass:"c-bubble-summary-chart",attrs:{"highlight-building-id":_vm.building.id,"chart-data":_vm.chartData},on:{"click":_vm.onBubbleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }